import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AutoFocusDirectiveDirective } from 'src/app/modules/shared/directives/auto-focus-directive.directive';

// Bootstrap Icons
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';
import {
  plusCircle, plusCircleFill,
  tags, tagsFill,
  calendar2Plus, calendar2PlusFill,
  collection, collectionFill,
  barChart, barChartFill,
  creditCard, creditCardFill,
  star, starFill,
  caretRight, caretRightFill,
  caretLeft, caretLeftFill,
  caretUp, caretUpFill,
  caretDown, caretDownFill,
  clipboardData, clipboardDataFill,
  phone, phoneFill,
  chatSquareDots, chatSquareDotsFill,
  list,
  chevronLeft,
  infoCircle,
  arrowRight,
  arrowLeft,
  arrowDown,
  arrowUp,
  calendarCheck,
  pencilSquare,
  xCircle,
  checkCircle,
  x,
  trash3,
  cloudArrowUp,
  search,
  clockHistory,
  check2Circle,
  grid,
  sortDown,
  sortUpAlt,
  sliders,
  filetypeCsv,
  app
} from 'ngx-bootstrap-icons';

const BootstrapIconList = {
  plusCircle, plusCircleFill,
  tags, tagsFill,
  calendar2Plus, calendar2PlusFill,
  caretRight, caretRightFill,
  caretLeft, caretLeftFill,
  caretUp, caretUpFill,
  caretDown, caretDownFill,
  collection, collectionFill,
  barChart, barChartFill,
  creditCard, creditCardFill,
  star, starFill,
  clipboardData, clipboardDataFill,
  phone, phoneFill,
  chatSquareDots, chatSquareDotsFill,
  arrowRight,
  arrowLeft,
  arrowDown,
  arrowUp,
  list,
  chevronLeft,
  infoCircle,
  calendarCheck,
  pencilSquare,
  xCircle,
  checkCircle,
  x,
  trash3,
  cloudArrowUp,
  search,
  clockHistory,
  check2Circle,
  grid,
  sortDown,
  sortUpAlt,
  sliders,
  filetypeCsv,
  app
};

import { ToastrModule } from 'ngx-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgChartsModule } from 'ng2-charts';
import { AgGridModule } from 'ag-grid-angular';
import { NgxCsvParserModule } from 'ngx-csv-parser';

import { CpgRegistrationComponent } from './components/cpg-registration/cpg-registration.component';
import { CreateCouponStepsComponent } from './components/create-coupon-steps/create-coupon-steps.component';
import { CreateCouponSelectProductsComponent } from './components/create-coupon-select-products/create-coupon-select-products.component';
import { CreateCouponSetDetailsComponent } from './components/create-coupon-set-details/create-coupon-set-details.component';
import { CreateCouponSelectRetailersComponent } from './components/create-coupon-select-retailers/create-coupon-select-retailers.component';
import { CreateCouponSubmitComponent } from './components/create-coupon-submit/create-coupon-submit.component';
import { CreateCouponPreviewComponent } from './components/create-coupon-preview/create-coupon-preview.component';
import { ShowCouponComponent } from './components/show-coupon/show-coupon.component';
import { PreviewCouponComponent } from './components/preview-coupon/preview-coupon.component';
import { ChartjsBarComponent } from './components/chartjs-bar/chartjs-bar.component';
import { ChartjsLineComponent } from './components/chartjs-line/chartjs-line.component';
import { ManageCategoryComponent } from './components/manage-category/manage-category.component';
import { ManageManufacturerComponent } from './components/manage-manufacturer/manage-manufacturer.component';
import { ManageBrandComponent } from './components/manage-brand/manage-brand.component';

@NgModule({
  declarations: [
    AutoFocusDirectiveDirective,
    CpgRegistrationComponent,
    CreateCouponStepsComponent,
    CreateCouponSelectProductsComponent,
    CreateCouponSetDetailsComponent,
    CreateCouponSelectRetailersComponent,
    CreateCouponSubmitComponent,
    CreateCouponPreviewComponent,
    ShowCouponComponent,
    PreviewCouponComponent,
    ChartjsBarComponent,
    ChartjsLineComponent,
    ManageCategoryComponent,
    ManageManufacturerComponent,
    ManageBrandComponent,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,

    NgbModule,
    NgxPaginationModule,
    NgxDropzoneModule,
    BsDatepickerModule,
    ModalModule.forRoot(),
    ToastrModule.forRoot(),
    AccordionModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    TooltipModule.forRoot(),
    NgChartsModule,
    AgGridModule,
    NgxCsvParserModule,
    NgxBootstrapIconsModule.pick(BootstrapIconList)
  ],
  exports: [
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,

    NgbModule,
    NgxPaginationModule,
    ModalModule,
    ToastrModule,
    NgxDropzoneModule,
    AccordionModule,
    BsDatepickerModule,
    NgMultiSelectDropDownModule,
    TooltipModule,
    NgChartsModule,
    AgGridModule,
    NgxCsvParserModule,
    NgxBootstrapIconsModule,

    AutoFocusDirectiveDirective,
    CpgRegistrationComponent,
    CreateCouponStepsComponent,
    CreateCouponSelectProductsComponent,
    CreateCouponSetDetailsComponent,
    CreateCouponSelectRetailersComponent,
    CreateCouponSubmitComponent,
    CreateCouponPreviewComponent,
    ShowCouponComponent,
    PreviewCouponComponent,
    ChartjsBarComponent,
    ChartjsLineComponent,
    ManageCategoryComponent,
    ManageManufacturerComponent,
    ManageBrandComponent,
  ],
})
export class SharedModule {}
